<template>
  <router-view />
</template>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  width: 100%;
  height: 100vh;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  overflow: hidden;
  min-height: 740px;
  min-width: 1684px;
}
</style>
